export const ADVANCED_TYPES = {
  ACCORDION: "accordion",
  MULTIPLE_CHOICE: "multiple-choice",
  MULTIPLE_SELECT: "multiple-select",
  ESSAY: "essay",
  FILL_IN_BLANK: "fill-in-blank",
  VIDEO: "video",
  FULL_ROW_VIDEO: "full-row-video",
};
